import {EpLayer} from "./layer";
import {inventoryZonesStyle} from "../styles/inventory_zones";
import {Style} from "ol/style";

export class EpInventoryZonesLayer extends EpLayer {
    constructor(map) {
        super(map);

        this.style = inventoryZonesStyle;
        this.title = 'Obszary inwentaryzacji';
        this.farStyle = new Style();

        return this;
    }

    addInventoryZonesFromObject(zones, options = {}) {
        for(let zone of zones) {
            this.addFeature(zone.coordinates, {
                resize: options.resize ?? false,
                fields: {
                    id: zone.id,
                    'zone-data': zone,
                    type: 'inventory-zone',
                    zoomLimit: 10,
                }
            });
        }
    }
}
